import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';

export const webinarAPI = createApi({
  reducerPath: 'webinarAPI',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getMortgageWebinarList: builder.query<
      ApiResponse<any>,
      {
        page: number;
        pageSize?: number;
        fieldFilters?: { key: string; value: string }[];
      }
    >({
      query: ({ page, pageSize = 10, fieldFilters }) => {
        const params: Record<string, any> = {
          _labels: '1',
          page_size: pageSize,
          current_page: page,
        };

        if (fieldFilters && fieldFilters.length > 0) {
          params.search = JSON.stringify({ field_filters: fieldFilters });
        }

        return {
          url: `v1/mortgage-webinar/list`,
          method: 'GET',
          params,
        };
      },
    }),
    updateMortgageWebinarApplicationStatus: builder.mutation<
      ApiResponse<any>,
      { entryId: string; applicationStatus: string }
    >({
      query: ({ entryId, applicationStatus }) => {
        return {
          url: `v1/mortgage-webinar/update-application-status`,
          method: 'PATCH',
          body: { entryId, applicationStatus },
        };
      },
    }),
  }),
});

export const {
  useGetMortgageWebinarListQuery,
  useUpdateMortgageWebinarApplicationStatusMutation,
} = webinarAPI;
